import React from 'react';
import {connectWithCore} from 'framework/hocs';
import _ from 'lodash';
import {checkIfEmailIsValid, checkIfEmailIsPivFEMA} from '../../common/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {
  RadioField,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {FileUpload} from 'go/components/common/attachments';
import {Button, Input, Form} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {Alert} from 'componentLibrary';

export class PanelReviewAddChair extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newChairId: '',
      error: false,
      errorCode: '',
      addPanelist: 'single',
      selectedFile: [],
      uploadError: false,
      emailError: '',
      disableAdd: true,
    };
  }

  handleInputChange = (event) => {
    const {value} = event.target;
    this.setState((prevState) => {
      return {addPanelist: value};
    });
  };

  handleEmailChange = (event) => {
    const {name, value} = event.target;
    if (value.length == 0) {
      this.setState({...this.state, [name]: '', emailError: '', disableAdd: true});
      return;
    }

    if (checkIfEmailIsValid(value) && checkIfEmailIsPivFEMA(value)) {
      this.setState({...this.state, [name]: value, emailError: '', disableAdd: false});
    } else {
      this.setState({
        ...this.state,
        [name]: value,
        emailError: 'You must use a valid Email address',
        disableAdd: true,
      });
    }
  };

  clearErrors = () => {
    this.setState((prevState) => ({...prevState, errorCode: ''}));
  };

  noRowsError() {
    return (
      <React.Fragment>
        <Alert header="Error in Excel document:" type="error">
          <strong>
            Please make sure you input at least one Chair id in the template.
          </strong>
        </Alert>
      </React.Fragment>
    );
  }

  uploadAttachment = (error, files) => {
    this.props.setUploadError(error);
    if (!_.isEmpty(files)) {
      this.setState({
        selectedFile: files[0],
      });
    }
  };

  downloadTemplateLink = () => {
    return REST.panelReviewV2.getPanelsAttachment();
  };

  render() {
    const {
      error,
      errorText,
      selectedFile,
      newChairId,
      emailError,
      disableAdd,
    } = this.state;

    let btnLabel = 'Add panel chair';
    let disableSave = false;

    if (this.state.addPanelist === 'bulk') {
      btnLabel = 'Save';
      disableSave = _.isEmpty(selectedFile);
    }

    return (
      <FemaGoModal
        open={this.props.showModal === true}
        title="Add panel chair"
        cancelAction={() => {
          this.props.openManageTeamModal();
        }}
        confirmAction={async () => {
          this.state.addPanelist === 'single'
            ? await this.props.addChairRole(newChairId)
            : await this.props.saveChairRole(selectedFile);
          this.props.openManageTeamModal();
          this.props.getChairs();
          this.setState({...this.state, newChairId: ''});
        }}
        buttonText={btnLabel}
        disableButton={
          this.state.addPanelist === 'bulk'
            ? this.props.uploadError || disableSave
            : disableAdd
        }
      >
        <Form>
          <RadioField
            id="addPanelChairOptions"
            name="addPanelChairOptions"
            value={this.state.addPanelist}
            handleChange={this.handleInputChange}
            handleBlur={this.props.handleBlur}
            options={[
              {label: 'Add single panel chair', value: 'single'},
              {label: 'Bulk upload panel chairs', value: 'bulk'},
            ]}
          />
          {this.state.addPanelist === 'single' && (
            <div>
              <p>
                {
                  'For FEMA users, please use PIV-ID email addresses (e.g. 012345678@dhs.gov) for access to competitive merit review sessions. Once you upload your panel chair, you will see them in the panel chair list where they will be initially listed as inactive until you are ready to activate them.'
                }
              </p>
              <p>
                <strong>Input the email to add the user to the panel session.</strong>
              </p>
              <TextBoxField
                value={newChairId}
                id="email"
                name="newChairId"
                displayError={this.state.emailError}
                handleChange={this.handleEmailChange}
                maxLength={101}
                errorMessages={emailError}
              />
            </div>
          )}
          {this.state.addPanelist === 'bulk' && (
            <div>
              {error && errorText ? (
                <Alert header="Upload error" type="error">
                  <strong>{errorText}</strong>
                </Alert>
              ) : (
                ''
              )}
              <p>
                To upload multiple panel chairs, please download the&nbsp;
                <a href={this.downloadTemplateLink()} target="_blank">
                  panelist upload template
                </a>
                , follow the instructions on 'Info' tab in the template and upload the
                list of panel chairs using the document uploader below. Please use PIV-ID
                email addresses (e.g. 012345678@dhs.gov) for access to competitive merit
                review sessions. Once you upload your panel chairs, you will see them in
                the panel chair list where they will be initially listed as inactive until
                you are ready to activate them.
              </p>
              <div onClick={this.clearErrors}>
                {this.state.errorCode === 'NO_ROWS' && this.noRowsError()}
                <FileUpload
                  uploadAttachment={this.uploadAttachment}
                  acceptedFileTypes={['.xlsx']}
                  noFileDesc={true}
                  attachmentType="bulk-panelist-upload"
                />
              </div>
            </div>
          )}
        </Form>
      </FemaGoModal>
    );
  }
}

export default connectWithCore(PanelReviewAddChair);
